import { render, staticRenderFns } from "./RegisterLaboratory.html?vue&type=template&id=331ef6ac&external"
import script from "./RegisterLaboratory.vue?vue&type=script&lang=js"
export * from "./RegisterLaboratory.vue?vue&type=script&lang=js"
import style0 from "./RegisterLaboratory.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports